import React, { useMemo } from 'react';
import styles from './PodiumSparks.module.css';

const SPARK_COUNT = 14;

const PodiumSparks = ({ variant }) => {
  const sparks = useMemo(
    () =>
      Array.from({ length: SPARK_COUNT }, (_, i) => ({
        id: i,
        left: Math.random() * 90 + 5,
        bottom: Math.random() * 30,
        size: 5 + Math.random() * 6,
        duration: 4 + Math.random() * 6,
        delay: -Math.random() * 8,
        drift: (Math.random() - 0.5) * 60,
      })),
    []
  );

  return (
    <div className={`${styles.sparks} ${styles[variant] || ''}`} aria-hidden="true">
      {sparks.map((s) => (
        <span
          key={s.id}
          className={styles.spark}
          style={{
            left: `${s.left}%`,
            bottom: `${s.bottom}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            animationDuration: `${s.duration}s`,
            animationDelay: `${s.delay}s`,
            '--drift': `${s.drift}px`,
          }}
        />
      ))}
    </div>
  );
};

export default PodiumSparks;
